<script setup lang="ts">
import { DividerFormElement } from "~/api";

const props = defineProps<{ modelValue: DividerFormElement }>();
</script>

<template>
  <div
    :class="['DividerComponent', modelValue.properties.thickness + '-divider']"
  >
    <div
      v-if="modelValue.label"
      class="line"
      :class="{ 'show-line': modelValue.properties.displayLine }"
    ></div>
  </div>
</template>
<style lang="less">
.component-renderer {
  &.component-indent-level-0 {
    .DividerComponent {
      margin-right: -6px;
      margin-left: -14px;
    }
  }
  &.component-indent-level-1 {
    .DividerComponent {
      margin-right: -6px;
      margin-left: -20px;
    }
  }
  &.component-indent-level-2 {
    .DividerComponent {
      margin-right: 32px;
    }
  }
  &.component-indent-level-3 {
    .DividerComponent {
      margin-right: 48px;
    }
  }
  &.component-indent-level-4 {
    .DividerComponent {
      margin-right: 64px;
    }
  }
  &.component-indent-level-5 {
    .DividerComponent {
      margin-right: 80px;
    }
  }
}
.DividerComponent {
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.Thin-divider {
    height: 5px;
    .line {
      height: 2px;
      border: 1px solid var(--el-text-color-primary);
    }
  }

  &.Medium-divider {
    height: 15px;
    .line {
      height: 4px;
      border: 2px solid var(--el-text-color-primary);
      border-radius: 2px;
    }
  }

  &.Thick-divider {
    height: 30px;
    .line {
      height: 12px;
      border: 6px solid var(--el-text-color-primary);
      border-radius: 3px;
    }
  }

  .line {
    display: none;

    &.show-line {
      display: block;
    }
  }
}
</style>
